module.exports = __webpack_public_path__ + "static/media/speakers_carousel_landing_2.b5ee898c.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/speakers_carousel_landing_2.png
// module id = 1139
// module chunks = 0